export default "__VITE_ASSET__bPWqXZMr__"